import {get, apiRoutes} from './../../api/api';

export const REQUEST_ARTICLE = 'REQUEST_ARTICLE';
export const RECEIVE_ARTICLE = 'RECEIVE_ARTICLE';
export const REQUEST_ARTICLE_VERSIONS = 'REQUEST_ARTICLE_VERSIONS';
export const RECEIVE_ARTICLE_VERSIONS = 'RECEIVE_ARTICLE_VERSIONS';
export const REQUEST_ARTICLE_COMPARE = 'REQUEST_ARTICLE_COMPARE';
export const RECEIVE_ARTICLE_COMPARE = 'RECEIVE_ARTICLE_COMPARE';
export const REQUEST_ARTICLE_CONCEPT = 'REQUEST_ARTICLE_CONCEPT';

function requestArticle(id) {
  return {
    type: REQUEST_ARTICLE,
    id: id
  };
}

function receiveArticle(id, data) {
  return {
    type: RECEIVE_ARTICLE,
    item: data,
    id: id,
    receivedAt: Date.now()
  };
}

export function fetchArticle(id) {
  return dispatch => {
    dispatch(requestArticle(id));
    const url = apiRoutes.articles.get(id);
    return get(url, function (response) {
      dispatch(receiveArticle(id, response.data));
    });
  };
}

function requestArticleVersions(id, versiontype) {
  return {
    type: REQUEST_ARTICLE_VERSIONS,
    versiontype: versiontype,
    id: id
  };
}

function receiveArticleVersions(id, versiontype, data) {
  return {
    type: RECEIVE_ARTICLE_VERSIONS,
    item: data,
    versiontype: versiontype,
    id: id,
    receivedAt: Date.now()
  };
}

export function fetchArticleVersions(id, versiontype) {
  return dispatch => {
    dispatch(requestArticleVersions(id));
    const url = apiRoutes.articles.getVersions(id, versiontype);
    return get(url, function (response) {
      dispatch(receiveArticleVersions(id, versiontype, response.data));
    });
  };
}

function requestArticleCompare(id) {
  return {
    type: REQUEST_ARTICLE_COMPARE,
    id: id
  };
}

function receiveArticleCompare(id, data) {
  return {
    type: RECEIVE_ARTICLE_COMPARE,
    item: data,
    id: id,
    receivedAt: Date.now()
  };
}

export function fetchArticleCompare(id) {
  return dispatch => {
    dispatch(requestArticleCompare(id));
    const url = apiRoutes.articles.get(id);
    return get(url, function (response) {
      dispatch(receiveArticleCompare(id, response.data));
    });
  };
}

function requestArticleFromConcept() {
  return {
    type: REQUEST_ARTICLE_CONCEPT
  };
}

export function fetchArticleFromElementConcept(conceptId, language = null) {
  return dispatch => {
    dispatch(requestArticleFromConcept());
    const url = apiRoutes.articles.getFromConcept(conceptId, language);
    return get(url, function (response) {
      dispatch(receiveArticle(response.data.id, response.data[0]));
      return response.data[0];
    });
  };
}

export function fetchConcept(id) {
  return dispatch => {
    dispatch(requestArticle(id));
    const url = apiRoutes.elements.getConcept(id);
    return get(url, function (response) {
      dispatch(receiveArticle(id, response.data));
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/modules/articles/actions.js
 **/